export let Integration;
(function (Integration) {
  Integration["Wordpress"] = "wordpress";
  Integration["Wpforms"] = "wpforms";
  Integration["Shopify"] = "shopify";
  Integration["Typeform"] = "typeform";
  Integration["ShopifyEmbedded"] = "shopify-embedded";
  Integration["GoogleWorkspaceApp"] = "google-workspace-app";
})(Integration || (Integration = {}));